<div class="content" role="main">

  <h2>Ingredient Taxonomy Call</h2>
  <p>Retrieve the taxonomy of some ingredients (INCI Name, CAS Number, Function,  Restriction, CosIng Reference Number, Description, CosIng Update Date) from the cosmethics database</p>

  <form class="forms widthMax" [formGroup]="getINCIInformationForm" (ngSubmit)="onSubmit()">

    <mat-accordion class="example-headers-align widthMax"  >

      <!-- ** Dates ** -->
      <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
        <!--        <ng-container *ngTemplateOutlet="matExpansionPanelHeader context: header"></ng-container>-->

        <mat-expansion-panel-header>
          <mat-panel-title>
            Dates of update
          </mat-panel-title>
          <mat-panel-description *ngIf="!getINCIInformationForm.value.range.startDate && !getINCIInformationForm.value.range.endDate else panelDescriptionDateSelected" >
            Select the range on which you want the INCI to have been updated
            <!--            <mat-icon>account_circle</mat-icon>-->
          </mat-panel-description>
          <ng-template #panelDescriptionDateSelected>
            <mat-panel-description>
              <span class="title">Start </span> {{getINCIInformationForm.value.range.startDate | date}}
              <span class="title">End </span> {{getINCIInformationForm.value.range.endDate | date}}
            </mat-panel-description>
          </ng-template>
        </mat-expansion-panel-header>

        <div class="spaceAround">
          <button mat-raised-button type="button" color="primary" (click)="selectFullRange()">Full range</button>
          <mat-form-field appearance="fill">
            <mat-label>Enter a specific date range</mat-label>
            <mat-date-range-input formGroupName="range" [rangePicker]="picker">
              <input matStartDate formControlName="startDate" placeholder="Start date">
              <input matEndDate formControlName="endDate" placeholder="End date">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        </div>

<!--        <app-mat-action-row-personnalised [firstStep]="true" [disabled]="!getINCIInformationForm.value.range.startDate && !getINCIInformationForm.value.range.endDate"></app-mat-action-row-personnalised>-->
        <ng-container *ngTemplateOutlet="matActionRow context: {firstStep:true, disabled:!getINCIInformationForm.value.range.startDate && !getINCIInformationForm.value.range.endDate}"></ng-container>

      </mat-expansion-panel>

      <!-- ** INCIs exact match ** -->
      <mat-expansion-panel [expanded]="step === 1" [disabled]="step < 1" [hideToggle]="step < 1 && !getINCIInformationForm.value.range.startDate" (opened)="setStep(1)"  >
        <mat-expansion-panel-header>
          <mat-panel-title>
            INCIs exact match
          </mat-panel-title>
          <mat-panel-description *ngIf="!INCIExactMatchSelected else panelDescriptionINCIExactMatchSelected">
            Filter on the exact name of the INCIs typed or selected
            <!--            <mat-icon>account_circle</mat-icon>-->
          </mat-panel-description>
          <ng-template #panelDescriptionINCIExactMatchSelected>
            <mat-panel-description class="overflowHidden">
              <span class="title"> {{ getINCIInformationForm.value.INCIs_exact.length > 0 ? "Some INCIs selected" : "All INCIs selected" }} </span>
            </mat-panel-description>
          </ng-template>
        </mat-expansion-panel-header>

        <div>
          <button mat-raised-button type="button" color="primary" (click)="selectAllINCIs()">Select All</button>
        </div>
        <mat-form-field class="chip-list">
          <mat-chip-list #chipListINCIExactMatch >
            <ng-container *ngTemplateOutlet="chip context: INCIExactMatchChipElement"></ng-container>
            <input
              placeholder="Add INCI..."
              #INCIExactMatchInput
              [formControl]="INCIExactMatchCtrl"
              [matChipInputFor]="chipListINCIExactMatch"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matAutocomplete]="autoINCIExactMatch"
              (matChipInputTokenEnd)="add($event, INCIExactMatchCtrl, INCIExactMatchChipElement.arrayString, INCIExactMatchChipElement.formArrayName, true)">
          </mat-chip-list>
          <mat-autocomplete #autoINCIExactMatch="matAutocomplete" (optionSelected)="selected($event,INCIExactMatchCtrl, INCIExactMatchChipElement.arrayString, INCIExactMatchChipElement.formArrayName, true)">
            <mat-option *ngFor="let INCI of usefulFunctionsService.possibleINCIs" [value]="INCI">
              {{INCI}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <ng-container *ngTemplateOutlet="matActionRow context: {disabled:!INCIExactMatchSelected}"></ng-container>
      </mat-expansion-panel>


      <!-- ** INCIs contains** -->
      <mat-expansion-panel [expanded]="step === 2" [disabled]="step < 2" [hideToggle]="step < 2" (opened)="setStep(2)" hideToggle >
        <mat-expansion-panel-header>
          <mat-panel-title>
            INCIs contains
          </mat-panel-title>
          <mat-panel-description *ngIf="!INCIContainSelected else panelDescriptionINCIContainSelected">
            Filter on the name that the INCI will contain inside their name (eg: "AQUA" return "AQUA", "AQUAMARINE EXTRACT"....)
            <!--            <mat-icon>account_circle</mat-icon>-->
          </mat-panel-description>
          <ng-template #panelDescriptionINCIContainSelected>
            <mat-panel-description class="overflowHidden">
              <span class="title"> {{ getINCIInformationForm.value.INCIs_contain.length > 0 ? "Some INCIs selected" : "None, step skipped" }} </span>
            </mat-panel-description>
          </ng-template>
        </mat-expansion-panel-header>

        <div>
          <button mat-raised-button type="button" color="primary" (click)="skipINCIsContains()">Skip this step</button>
        </div>
        <mat-form-field class="chip-list">
          <mat-chip-list #chipListINCIContain >
            <ng-container *ngTemplateOutlet="chip context: INCIContainChipElement"></ng-container>
            <input
              placeholder="Add INCI..."
              #INCIContainInput
              [formControl]="INCIContainCtrl"
              [matChipInputFor]="chipListINCIContain"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="add($event, INCIContainCtrl, INCIContainChipElement.arrayString, INCIContainChipElement.formArrayName, true)">
          </mat-chip-list>
        </mat-form-field>

        <ng-container *ngTemplateOutlet="matActionRow context: {disabled:!INCIContainSelected}"></ng-container>
      </mat-expansion-panel>

      <!-- ** CAS Number ** -->
      <mat-expansion-panel [expanded]="step === 3" [disabled]="step < 3" [hideToggle]="step < 3" (opened)="setStep(3)" hideToggle  >
        <mat-expansion-panel-header>
          <mat-panel-title>
            CAS Number
          </mat-panel-title>
          <mat-panel-description *ngIf="!CASSelected else panelDescriptionCASSelected">
            Filter on the CAS number of the INCI (eg: 7732-18-5)
          </mat-panel-description>
          <ng-template #panelDescriptionCASSelected>
            <mat-panel-description class="overflowHidden">
              <span class="title"> {{ getINCIInformationForm.value.CAS_no.length > 0 ? "Some CAS selected" : "None, step skipped" }} </span>
            </mat-panel-description>
          </ng-template>
        </mat-expansion-panel-header>

        <div>
          <button mat-raised-button type="button" color="primary" (click)="skipCASNumber()">Skip this step</button>
        </div>
        <mat-form-field class="chip-list">
          <mat-chip-list #chipListCAS >
            <ng-container *ngTemplateOutlet="chip context: CASChipElement"></ng-container>
            <input
              placeholder="Add a CAS number..."
              #CASInput
              [formControl]="CASCtrl"
              [matChipInputFor]="chipListCAS"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="add($event, CASCtrl, CASChipElement.arrayString, CASChipElement.formArrayName, false)">
          </mat-chip-list>
        </mat-form-field>

        <ng-container *ngTemplateOutlet="matActionRow context: {disabled:!CASSelected}"></ng-container>
      </mat-expansion-panel>

      <!-- ** Functions ** -->
      <mat-expansion-panel [expanded]="step === 4" [disabled]="step < 4" [hideToggle]="step < 4" (opened)="setStep(4)" hideToggle  >
        <mat-expansion-panel-header>
          <mat-panel-title>
            Function
          </mat-panel-title>
          <mat-panel-description *ngIf="!functionSelected else panelDescriptionFunctionSelected">
            Filter on the function the INCI has in the cosmetic product (eg: ABRASIVE)
          </mat-panel-description>
          <ng-template #panelDescriptionFunctionSelected>
            <mat-panel-description class="overflowHidden">
              <span class="title"> {{ getINCIInformationForm.value.functions.length > 0 ? "Some Functions selected" : "None, step skipped" }} </span>
            </mat-panel-description>
          </ng-template>
        </mat-expansion-panel-header>

        <div>
          <button mat-raised-button type="button" color="primary" (click)="skipFunction()">Skip this step</button>
        </div>
        <mat-form-field class="chip-list">
          <mat-chip-list #chipListFunction >
            <ng-container *ngTemplateOutlet="chip context: functionChipElement"></ng-container>
            <input
              placeholder="Select some functions"
              #functionInput
              [formControl]="functionCtrl"
              [matChipInputFor]="chipListFunction"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matAutocomplete]="autoFunction">
          </mat-chip-list>
          <mat-autocomplete #autoFunction="matAutocomplete" (optionSelected)="selected($event,functionCtrl, functionChipElement.arrayString, functionChipElement.formArrayName, false)">
            <mat-option *ngFor="let function of possibleFunctions" [value]="function">
              {{function}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <ng-container *ngTemplateOutlet="matActionRow context: {disabled:!functionSelected}"></ng-container>
      </mat-expansion-panel>

      <!-- ** Functions ** -->
      <mat-expansion-panel [expanded]="step === 5" [disabled]="step < 5" [hideToggle]="step < 5" (opened)="setStep(5)" hideToggle  >
        <mat-expansion-panel-header>
          <mat-panel-title>
            Restriction
          </mat-panel-title>
          <mat-panel-description *ngIf="!restrictionSelected else panelDescriptionRestrictionSelected">
            Filter on the annex restriction the INCI has (eg: Annex II, III, IV, V or VI)
          </mat-panel-description>
          <ng-template #panelDescriptionRestrictionSelected>
            <mat-panel-description class="overflowHidden">
              <span class="title"> {{ getINCIInformationForm.value.restrictions.length > 0 ? getINCIInformationForm.value.restrictions.join(', ') : "None, step skipped" }} </span>
            </mat-panel-description>
          </ng-template>
        </mat-expansion-panel-header>

        <div>
          <button mat-raised-button type="button" color="primary" (click)="skipRestriction()">Skip this step</button>
        </div>
        <mat-form-field class="chip-list">
          <mat-chip-list #chipListRestriction >
            <ng-container *ngTemplateOutlet="chip context: restrictionChipElement"></ng-container>
            <input
              placeholder="Select some restrictions"
              #restrictionInput
              [formControl]="restrictionCtrl"
              [matChipInputFor]="chipListRestriction"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matAutocomplete]="autoRestriction">
          </mat-chip-list>
          <mat-autocomplete #autoRestriction="matAutocomplete" (optionSelected)="selected($event,restrictionCtrl, restrictionChipElement.arrayString, restrictionChipElement.formArrayName, false)">
            <mat-option *ngFor="let restriction of possibleRestrictions" [value]="restriction">
              {{restriction}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <ng-container *ngTemplateOutlet="matActionRow context: {disabled:!restrictionSelected}"></ng-container>
      </mat-expansion-panel>

    </mat-accordion>

    <button mat-raised-button color="accent" type="submit" class="margin" [disabled]="!getINCIInformationForm.valid || !restrictionSelected">Submit</button>

  </form>

  <button mat-raised-button color="primary" type="button" class="margin" (click)="usefulFunctionsService.downloadData(results, 'INCIInformation')" [disabled]="!results">Download Results</button>

  <!--  <p>Results: {{results | json}}</p>-->

  <p *ngIf="results">Current products: {{skip +" to " + currentMax }}</p>
  <p *ngIf="results && results.total">Total products found: {{ results.total }}</p>

  <div>
    <button mat-raised-button color="accent" type="button" class="margin" (click)="getPreviousBatch()" [disabled]="!results || skip == 0">Get the previous {{limit}} products</button>
    <button mat-raised-button color="accent" type="button" class="margin" (click)="getNextBatch()" [disabled]="results  && results.total < limit || !results || results.length < limit">Get the next {{nextSkip}} products</button>
  </div>

</div>

<!-- TEMPLATES -->

<!-- Chip Element -->
<ng-template #chip let-arrayString="arrayString" let-formArrayName="formArrayName">
  <mat-chip
    *ngFor="let string of arrayString"
    [selectable]="selectable"
    [removable]="removable"
    (removed)="chipListComponent.remove(string, arrayString,formArrayName, this.getINCIInformationForm)">
    {{string}}
    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
  </mat-chip>
</ng-template>

<!-- mat-action-row -->
<ng-template #matActionRow let-firstStep="firstStep" let-disabled="disabled">
  <mat-action-row>
    <button *ngIf="!firstStep" mat-button color="warn" type="button" (click)="prevStep()">Previous</button>
    <button mat-button color="primary" type="button" [disabled]="disabled" (click)="nextStep()">Next</button>
  </mat-action-row>
</ng-template>

